import React, { Component } from 'react';
import { BaseButton } from '@stelecom/ui-react/components/buttons/baseButton';
import Input from '@stelecom/ui-react/components/input';
class EnterPhoneOrEmail extends Component {
    state = {
        clientContact: '',
        buttonDisabled: true
    }

    inputRef = React.createRef();

    setValue = (value) => {
        this.inputRef?.current?.validate(value);
        this.setState({
            clientContact: value,
            buttonDisabled: this.inputRef.current.state.hasError
        });
    }

    onEnterPress = (event) => {
        const { buttonDisabled, clientContact } = this.state;
        if (event.which === 13 && !buttonDisabled) {
            this.props.next(clientContact);
        }
    }

    render() {
        const { clientContact, buttonDisabled } = this.state;
        const { next, contactType } = this.props;
        const attrs = {
            onChange: (value) => this.setValue(value),
            onKeyPress: (event) => this.onEnterPress(event),
            required: true
        };
        if (contactType === 2) {
            attrs.key = 'phone';
            attrs.type = 'phone';
            attrs.errorMessage = 'Введите телефон';
        } else {
            attrs.key = 'email';
            attrs.type = 'email';
            attrs.errorMessage = 'Введите корректный адрес эл.почты. Допускаются только латинские буквы, цифры, знаки _+.-';
            attrs.value = clientContact;
        }
        return (
            <React.Fragment>
                <Input ref={this.inputRef} {...attrs} lazyMask={false} autoFocus placeholder='E-mail' errorMargin={true} />
                <BaseButton
                    block
                    onClick={() => next(clientContact)}
                    disabled={buttonDisabled}
                >
                    {'Далее'}
                </BaseButton>
            </React.Fragment>
        );
    }
}

export default EnterPhoneOrEmail;
